module.exports = __webpack_public_path__ + "assets/fonts/GothamRnd-BoldIta.a1b4c2b6.otf";